import { render, staticRenderFns } from "./AdvancedSection.vue?vue&type=template&id=2fb90fa7&"
import script from "./AdvancedSection.vue?vue&type=script&lang=js&"
export * from "./AdvancedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports